import { VoiceUITool } from './types'

/**
 * What the model is told about a set of voice tools: names, descriptions and
 * parameter schemas, without the functions. When this changes, a page must
 * re-register and a live session needs a session.update.
 */
export function voiceToolSurface(tools: VoiceUITool[]): string {
  return JSON.stringify(tools.map((t) => [t.name, t.description, t.parameters]))
}

/**
 * Whether the model should be told the page's description again.
 *
 * A page describes itself before its data arrives — a dashboard viewer says
 * "one page" while it loads, then its pages appear. The page-changed note is
 * composed at that first moment, so without this the model keeps answering
 * from the loading state (live, 11 Sep: "this dashboard only has one page",
 * about a dashboard with four).
 */
export function contextChanged(announced: string, current: string): boolean {
  const next = current.trim()
  return next !== '' && next !== announced.trim()
}
